module.exports = "/images/footer-logo@3x.png?2606b7a8beccb8de6e8a1901a9520e97";